export const warrantyFeeSelector = state => state.entities.warrantyFees;
